import styled, { css } from 'styled-components'
import GCashV2 from '../../../../../assets/img/gcash/gcash-logo-v2.svg'
import BannerBackground from '../../../../../assets/img/zing-points-banner/zing-banner-background.svg'

import LinkButton from '../../../../../components/ui/LinkButton/LinkButton'
import ActionButton from '../../../../../components/ui/ActionButton/ActionButton'
import media from '../../../../../services/generateMediaQueries'

const zingBannerButtonText = css`
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.08em;
`

export const ZingPointsBannerWrapper = styled.div`
  background-color: #4e6548;
  border-radius: var(--border-radius-card);
  margin: 1.5rem 1rem;
  /* background-image: url(${BannerBackground});
  background-size: cover;
  background-position: bottom; */
`
export const ZingPointsBannerContainer = styled.div`
  padding: 1.75rem 0.9rem;
  display: flex;
  flex-direction: column;
  background-size: 40%;
  background-position: bottom right;
  background-repeat: no-repeat;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ZingBannerTitle = styled.div`
  font-family: var(--font-family-ayala-display-sans);
  white-space: nowrap;
  font-weight: var(--font-weight-boldest);
  font-size: 1.25rem;
  color: var(--color-fg-inverse);
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`
export const ZingBannerSubtitle = styled.div`
  font-size: 0.8rem;
  color: var(--color-fg-inverse);
  letter-spacing: 0;
  line-height: 19px;
  margin-bottom: 1.5rem;
`
export const ButtonsContainer = styled.div`
  font-size: 1rem;
  display: flex;
  a,
  button {
    margin-right: 0.5rem;
  }
  a:last-of-type,
  button:last-of-type {
    margin-right: 0;
  }
`

export const StyledLinkButton = styled(LinkButton)`
  ${zingBannerButtonText}
  flex: 1;
  border: none;
  font-size: 0.8rem;
  background-color: ${({ variant }) => !variant && '#FFFFFF'};
  color: ${({ variant }) => !variant && 'var(--color-primary)'};
  &:hover {
    background-color: var(--color-primary-hover);
    border-color: var(--color-primary-hover);
  }
`

export const StyledActionButton = styled(ActionButton)`
  ${zingBannerButtonText}
  flex: 1;
  padding: 1rem;
  border: none;
  font-size: 0.8rem;
  background-color: ${({ variant }) => (variant ? '#672D8E' : '#F54590')};
  color: var(--color-fg-inverse) !important;
  :hover {
    color: ${({ variant }) => (variant ? '#672D8E' : '#F54590')} !important;
    background-color: var(--color-fg-inverse) !important;
  }

  ${media.lessThan('xxsmall')`
    font-size:0.65rem;
    img{
      height:1rem;
    }
  `}
`

export const GCashIcon = styled.img.attrs({ src: GCashV2 })`
  margin-right: 0.35rem;
  ${media.lessThan('xxsmall')`
      height:1rem;
  `}
`

export const GCashButton = styled(ActionButton)`
  ${zingBannerButtonText}
  flex: 1;
  padding: 1rem;
  border-color: #067dff;
  font-size: 0.8rem;
  background-color: #067dff;
  color: var(--color-fg-inverse) !important;
  :hover {
    border-color: var(--color-fg-inverse);
    background-color: #067dff;
  }
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${media.lessThan('xxsmall')`
    font-size:0.65rem;
  `}
`
export const LinkMoreButton = styled.a`
  display: block;
  padding-top: 1rem;
  font-size: 0.9rem;
  ${zingBannerButtonText} :hover {
    font-color: var(--color-fg-inverese);
  }
`

export const DummyButton = styled(ActionButton)`
  ${zingBannerButtonText}
  flex: 1;
  border: none;
  cursor: default;
`
